import React from "react";
import { useIntl } from "react-intl";
import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";

interface Introductions {
  title: string;
}

export const Introduction: React.FC<Introductions> = () => {
  const { formatMessage } = useIntl();

  return (
    <SimpleLayoutView>
      <div className={styles.introduction}>
        <div className={styles.rightComponent}>
          <h3 className={styles.title}>{formatMessage(messages.G2_P1_S1_Title)}</h3>
          <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G2_P1_S1_Description) }}></p>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
